import { Fragment, useEffect, useRef, useCallback } from "react";
import { Text } from "../../FormControls/Text";
import { Report } from '@mui/icons-material'
import { Stack } from "../../FormControls/Stack";
import { Input } from "../../FormControls/Input";
import { Selector } from "../../FormControls/Selector";
import { AlertBox } from "../../FormControls/alert";
import { ScreenControl } from "../ScreenControl";
import { useDispatch, useSelector } from "react-redux";
import { setAccountType, setAccountNumber, setAccountNumberConfirm, setAccountName, setBankName, retrieveBanksDetails, 
  retrieveBanks, setCountry, setBankData} from "../../../../main/slices/bankSlice";
import { LoadingComponent } from "../../LoadingComponent";
import { useState } from "react";
import { handleMinikitUser, setUserDiscountCode } from "../../../../main/slices/userSlice";
import { setTrxDiscountCode } from "../../../../main/slices/transactionSlice"

function getBankLogo(bank){
  let banks = {
    "Banco Industrial": {name: "Banco Industrial", extension: "png"},
    "Banco Promerica": {name: "Banco-Promerica", extension: "jpg"},
    "BAC": {name: "BAC", extension: "png"},
    "BAM": {name: "BAM", extension: "jpg"},
    "Banco G&T Continental": {name: "G&T", extension: "png"},
    "Banrural": {name: "Banrural", extension: "png"} ,
    "Crédito Hipotecario Nacional": {name: "Credito-Hipotecario-Nacional", extension: "jpg"},
    "BANTRAB": {name: "Bantrab", extension: "png"},
    "FICOHSA": {name: "Fichosa", extension: "jpg"},
    "Banco de Occidente": {name: "BancoOccidental", extension: "png"},
    "Banco Davivienda": {name: "Davivienda", extension: "webp"},
    "BANPAIS": {name: "BANPAIS", extension: "svg"},
    "FICENSA": {name: "FICENSA", extension: "jpg"},
    "BANHCAFE": {name: "BANHCAFE", extension: "png"},
    "Banco Atlántida": {name: "Banco Atlántida", extension: "svg"},
    "Banco Lafise": {name: "Banco Lafise", extension: "png"},
    "Banco Azteca": {name: "Banco Azteca", extension: "png"},
    "Banco Azteca": {name: "Banco Azteca", extension: "png"},
    "Banco Hipotecario": {name: "Banco Hipotecario", extension: "png"},
    "Banco Inmobilario": {name: "Banco-Inmobiliario", extension: "png"},
    "Banco Internacional": {name: "Interbanco", extension: "png"},
    "default": {name: "bankdefault", extension: "png"}
  }
  let b = banks[bank] ? banks[bank] : banks["default"];
  return `https://firebasestorage.googleapis.com/v0/b/coincaexchange.appspot.com/o/banks%2F${b.name}.${b.extension}?alt=media`;
}

const InfoBank = ({
  dispatch,
  children,
  bankState,
  types,
  banks,
  typeInput,
  inputMode,
  country,
  user,
  transaction,
}) => {

  const idWLD = useSelector(({ user }) => user.idWLD);
  const timerRefs = useRef({}); //--> Objeto para timers por key
  const [validateDiscountCode, setValidateDiscountCode] = useState(false);
  const [isSameCode, setIsSameCode] = useState(false);
  // TO AVOID SHOW LAST VALUES SAVED IN DB WHILE UPDATE THE NEW ONES 
  const [localValues, setLocalValues] = useState({});

  const updateInfoUser = (key, value) => {
    if(!idWLD){ return false; }
    //---> Actualizo el campo de usuario;
    const payload = { [key]: value };
    const Data = { payload, action: "update", userId: idWLD };

    dispatch(handleMinikitUser(Data))
      .unwrap()
      .then(({ response }) => {
        dispatch(setBankData(response.user));
      });
  }

  let handleChange = (key, value) => {
    // setLocalValues(prev => ({ ...prev, [key]: value }));
    if (key === "accountName"){ dispatch(setAccountName({ value, error: !value })); }
    else if (key === "accountType"){ dispatch(setAccountType({ value, error: !value })); }
    else if (key === "accountNumber"){ dispatch(setAccountNumber({value, error: !value})); }
    else if (key === "accountNumberConfirm"){ dispatch(setAccountNumberConfirm({ value, error: !value })); }
    else if (key === "bankName"){ dispatch(setBankName({ value, error: !value })); }
    else if (key === "code") {
      const codeInput = value.toUpperCase();
      let validate = /^[A-Z]{3}[0-9]{3}$/.test(codeInput);
      setValidateDiscountCode(validate);
      const userCode = (user.discountCode.value).toUpperCase();
      const newIsSameCode = codeInput !== userCode;
      setIsSameCode(newIsSameCode);
      dispatch(setTrxDiscountCode({ value: codeInput, error: !(validate && newIsSameCode) }));
    }
    
    // updateInfoUser(key, value);
  };

  const handleInputChange = useCallback((name, value) => {
    handleChange(name, value);
  }, []);

  return (
    <Fragment>
      {/* LEGEND */}
      {children}
      <div style={{ marginBottom: "1rem" }}></div>
      <Stack flex={{ flexDirection: "Column" }}>
        
        <Text classes={["description"]}> Datos de la cuenta </Text>
        <div style={{ marginBottom: "0.5rem" }}></div>
        <Stack flex={{ flexDirection: "row", gap: 10 }}>
          {/* BANK SELECT */}
          <Selector
            options={banks}
            onSelect={(val) => handleChange("bankName", val.label)}
            defaultValue={bankState.bankName.value}
            placeholder="Banco"
          />
          {/* ACCOUNT TYPE */}
          <Selector
            options={types}
            onSelect={(val) => handleChange("accountType", val.label)}
            defaultValue={bankState.accountType.value}
            placeholder="Tipo"
          />
        </Stack>
        <div style={{ marginBottom: "1rem" }}></div>
        <Stack flex={{ flexDirection: "column" }} >
          <Text classes={["description"]}> Nombre de la cuenta </Text>
          {bankState.accountName.value && bankState.accountName.error && (
            <Text
              classes={["annotation", "alignContent", "error"]}
              style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
            >
              <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
              Nombre inválido, comienza cada palabra con mayúsculas y verifica que no contengan números.
            </Text>
          )}
          <div style={{ marginBottom: "-0.5rem" }}></div>
          <Input
            attributes={{ value: bankState.accountName.value }}
            type="text"
            classes={["marginTB1em"]}
            onChange={({ target }) => handleInputChange("accountName", target.value)}
          />
        </Stack>
        
        <Stack flex={{ flexDirection: "column" }}>
          <Text classes={["description"]}> {(country == "CR") ? "Número de IBAN" : "Número de cuenta"} </Text>
          {//INVALIR EMAIL ALERT
            (bankState.accountNumber.value && bankState.accountNumber.error) &&
            <Text classes={["annotation", "alignContent", "error"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                El número de cuenta bancaria no parece válido, {(country == "CR") ? "revisa que tenga 20 dígitos y comience con CR" : "asegúrate que NO sea un número de tarjeta"}
            </Text>
          }
          <div style={{ marginBottom: "-0.5rem" }}></div>
          <Input
            attributes={{ value: localValues.accountNumber ?? bankState.accountNumber.value, inputMode: inputMode }}
            type={typeInput}
            classes={["marginTB1em"]}
            onChange={({ target }) => handleInputChange("accountNumber", target.value)}
            placeHolder=""
          />
        </Stack>

        <Stack flex={{ flexDirection: "column" }}>
          <Text classes={["description"]}> Confirma tu {(country == "CR") ? "número de IBAN" : "número de cuenta"} </Text>
          {//INVALIR EMAIL ALERT
            (bankState.accountNumberConfirm.value && bankState.accountNumber.value && bankState.accountNumberConfirm.value!=bankState.accountNumber.value) &&
            <Text classes={["annotation", "alignContent", "error"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                El número de cuenta bancaria no coincide
            </Text>
          }
          <div style={{ marginBottom: "-0.5rem" }}></div>
          <Input
            attributes={{ value: localValues.accountNumberConfirm ?? bankState.accountNumberConfirm.value, inputMode: inputMode }}
            type={typeInput}
            classes={["marginTB1em"]}
            onChange={({ target }) => handleChange("accountNumberConfirm", target.value)}
            placeHolder=""
          />
        </Stack>
      </Stack>
    </Fragment>
  );
};

const ScreenLegend = ({country}) => (
  <Stack flex={{ flexDirection: "column" }}>
    <Text classes={["title", "center"]}>
      {" "}INFORMACIÓN BANCARIA{" "}
    </Text>
    <Text classes={["subtitle"]}>
      {" "}Configura tu cuenta de banco {(country=="CR") ? "con IBAN" : ""} para recibir tus fondos acumulados.{" "}
    </Text>
  </Stack>
);

export const FormWithdrawalBank = ({ path }) => {
  const [banks, setBanks] = useState([]);
  const bankState = useSelector(({ bank }) => bank);
  const userInfo = useSelector(({ user }) => user);
  const trxInfo = useSelector(({ transaction }) => transaction);
  const country = useSelector(({ user }) => user.country.value);
  const [currencys, setCurrencys] = useState([]);
  const [types, setTypes] = useState([]);
  const [typeInput, setTypeInput] = useState("number");
  const [inputMode, setInputMode] = useState("numeric");
  const [disabledBtn, setDisabledBtn] = useState(true);
  const dispatch = useDispatch();

  // ALERT
  const [showAlert, setShowAlert] = useState(false); // view alert
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');

  // CLOSE ALERT MESSAGE
  const handleCloseAlert = () => setShowAlert(false);

  const validateRequiredInfoBank = () => {
    return (
      !bankState?.accountType?.error && // false -> true
      !bankState?.accountName?.error && // false -> true
      !bankState?.accountNumber?.error && // false -> true
      !(bankState?.accountNumber?.value!=bankState?.accountNumberConfirm?.value) && // // true -> false , false -> true
      !bankState?.bankName?.error
    );    
  }

  //---> Asignar el valor de los puntos para verificarce
  useEffect(() => {
    (async () => {
        try {
            //---> Habilito caracteres para las cuentas de CR;
            if(country == "CR") { setTypeInput("text"); setInputMode("text"); };
            dispatch(setCountry(country));

            //---> Obtengo la lista de bancos disponibles;
            let responseBanks = await dispatch(retrieveBanks()).unwrap();
            setBanks(responseBanks?.response?.map((b) => ({value: b, label: b, image: getBankLogo(b)})));

            //---> Obtengo los detalles de bancos disponibles;
            let {response} = await dispatch(retrieveBanksDetails()).unwrap();
            setCurrencys(response?.currencys);
            setTypes(response?.types);

        } catch (error) {
            return false;
        }
    })();
  },[dispatch]);

  useEffect(() => {
    setDisabledBtn(!validateRequiredInfoBank())
  }, [dispatch, bankState]);

  //---> Si aún no ha cargado los puntos;
  if(!types?.length||!currencys?.length||!banks?.length){ return (<Fragment><LoadingComponent /></Fragment>); }

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
          {/* Aquí muestra el AlertBox solo si showAlert es verdadero */}
          {showAlert && (
            <AlertBox
              message={`${alertMessage}`}
              // parrfo={`${trxInfo.discountCodeTrx.value} tendras un 2% de descuento en tu transacción`}
              type={alertType}
              onClose={handleCloseAlert}
            />
          )}

          {/* ACCOUNT COMPONENT */}
          <InfoBank
            dispatch={dispatch}
            types={types}
            banks={banks}
            currencys={currencys}
            bankState={bankState}        
            typeInput={typeInput}
            inputMode={inputMode}
            country={country}
            user={userInfo}
            transaction={trxInfo}
          >
            <ScreenLegend country={country}></ScreenLegend>
          </InfoBank>
        </div>
        {/* CONTROLLER */}
        <ScreenControl 
          btncolor={"cobrarBtn"}
          btnText={"Continuar"}
          // {...route()}
          disabled={disabledBtn}
        ></ScreenControl>
    </Fragment>
  );
};